export default "__VITE_ASSET__DtFvaCMS__"